export var referrerMapper = function (referrerId, linkName) { return ({
    schemaName: 'referrer',
    messageContent: {
        referrerId: referrerId,
        linkName: linkName,
        eventType: 'click'
    }
}); };
//# sourceMappingURL=referrer-mapper.js.map